import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DOWNLOAD_DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
} from '../../i18n';

export function useDownloadDefaultLocale(): void {
  const { i18n } = useTranslation();

  useEffect(() => {
    const hasUserLocale = typeof window !== 'undefined'
      && Boolean(window.localStorage.getItem(LOCALE_STORAGE_KEY));

    if (hasUserLocale || i18n.language === DOWNLOAD_DEFAULT_LOCALE) {
      return;
    }

    void i18n.changeLanguage(DOWNLOAD_DEFAULT_LOCALE);
  }, [i18n]);
}
